<template>
    <rkm-layout-body title="Lista de sala de vacinação">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'imunizacao-sala-vacinacao-create' })"
                authorize="store-imunizacao-sala-vacinacao"
                color="primary"
            >
                Cadastrar sala de vacinação
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/imunizacao/sala-vacinacao/List'

export default {
    components: { List },
}
</script>